package com.mxpainting.models

import kotlinx.serialization.Serializable

@Serializable
data class ContactRequest(
    val name: String,
    val email: String,
    val phone: String,
    val message: String,
    val turnstileResponse: String? = null
)
